
<template>
  <!--头部导航组件 -->
  <div class="topmenu">
    <el-menu :default-active="$route.path === '/remoteSenseData' ? activeIndex : activeIndex2" class="el-menu-demo"
      mode="horizontal" @select="handleSelect" background-color="#191b2e" text-color="#afb1c1"
      active-text-color="#1ccb96">
      <el-menu-item index="1" style="border-bottom:none;border-radius:35px 0 0 35px "
        @click="dialogFormVisible = true;setStyle = 'aaa';">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-thirdshuzi" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            {{this.$route.path === '/remoteSenseData' || $route.path === '/subscriptionData' ? '数据选择' : '产品选择'}}
          </span>
        </div>

      </el-menu-item>
      <head-class-dialog :prodata="prodata" class="dialogtop" :msg-father="dialogFormVisible"
        v-on:getdialogFormVisible="getDialogMsg" v-on:getproductselectinfos="getpsis">
      </head-class-dialog>
      <el-menu-item index="2" style="border-bottom:none;" @click="DaydialogFormVisible = true;setStyle = 'aaa';">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-thirdtwo-off" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            {{dateTitle}}
          </span>
        </div>
      </el-menu-item>
      <head-day-dialog :prodata="prodata" :rdate="rdate" :pdate="pdate" class="dialogtop"
        :msg-father="DaydialogFormVisible" v-on:getdaydialogFormVisible="getDayDialogMsg"
        v-on:getdaydialogFormDate="getDayDialogDate" v-on:showClassDialog="showClassDialog"></head-day-dialog>
      <el-menu-item index="3" style="border-bottom:none;" @click="showRegionDialog">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-third31" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            {{$route.path === '/subscriptionData' ? '空间范围' : '行政区域'}}
          </span>
        </div>
      </el-menu-item>
      <head-boundary-dialog :prodata="boundarydata" class="dialogtop" :msg-father="BoundarydialogFormVisible"
        :radio="radio" v-on:getboundarydialogFormVisible="getBoundaryDialogMsg" v-on:getRegioncode="sendMsgToParentPro"
        v-on:showWeftDialog="showWeftDialog" v-on:getdaydialogFormVisible="getDayDialogMsg"
        v-on:getSetdialogFormVisible="getSetDialogMsg">
      </head-boundary-dialog>
      <el-menu-item v-show="$route.path === '/subscriptionData'" index="8" style="border-bottom:none;"
        @click="showSetDialog">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i :class="setStyle" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            交付设置
          </span>
        </div>
      </el-menu-item>
      <head-delivery-set-dialog :prodata="boundarydata" :dscatalogs="selectsddatas" :startDate="sdstartdate"
        :endDate="sdenddate" :regionType="regionType" :regionId="regionId" :regionGeom="regionGeom" :remoteSenseFormData="remoteSenseFormData" class="dialogtop"
        :msg-father="SetdialogFormVisible" :radio="radio" v-on:getSetdialogFormVisible="getSetDialogMsg"
        v-on:getboundarydialogFormVisible="getBoundaryDialogMsg" v-on:getweftdialogFormVisible="getWeftDialogMsg">
      </head-delivery-set-dialog>
      <el-menu-item v-show="$route.path !== '/subscriptionData'" index="4" style="border-bottom:none;"
        @click="WeftdialogFormVisible = true;">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-thirdquyu" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            经纬度
          </span>
        </div>
      </el-menu-item>
      <head-weft-dialog :prodata="boundarydata" class="dialogtop" :msg-father="WeftdialogFormVisible" :radio="radio"
        v-on:getweftdialogFormVisible="getWeftDialogMsg" v-on:getQueryType="getQueryType" v-on:getRange="getRange"
        v-on:showBoundaryDialog="showBoundaryDialog" v-on:getdaydialogFormVisible="getDayDialogMsg"
        v-on:getSetdialogFormVisible="getSetDialogMsg">
      </head-weft-dialog>
      <el-menu-item index="5" style="border-bottom:none;" v-popover:drawpop
        v-show="$route.path !== '/subscriptionData'">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-thirdquyu1" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            绘制图形
          </span>
        </div>
        <el-popover ref="drawpop" placement="bottom" trigger="hover" popper-class="newpopover">
          <div class="popdiv" @click="drowp" id="drawstyle1"><i class="el-icon-delete rightgo"></i>矩形</div>
          <div class="popdiv" @click="drowd" id="drawstyle2"><i class="el-icon-delete rightgo"></i>多边形</div>
        </el-popover>
      </el-menu-item>

      <el-menu-item index="6" style="border-bottom:none;" @click="UpdatadialogFormVisible = true;"
        v-show="$route.path !== '/subscriptionData'">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-thirddingwei" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            上传坐标
          </span>
        </div>
      </el-menu-item>
      <head-updata-dialog :prodata="boundarydata" class="dialogtop" :msg-father="UpdatadialogFormVisible"
        v-on:getupdatadialogFormVisible="getUpdataDialogMsg" v-on:getQueryType="getQueryType" v-on:getRange="getRange">
      </head-updata-dialog>
      <el-menu-item index="7" style="border-bottom:none;border-radius: 0 35px  35px 0 ;" @click="cleardrow(0)"
        v-show="$route.path !== '/subscriptionData'">
        <div style="display:flex;flex-direction:column;line-height:1.8;">
          <i class="el-icon-thirdqingchu" style="margin-top:10px;width:100%;text-align:center;"></i>
          <span class="icon-name">
            清除图形
          </span>
        </div>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import '../../assets/fontawesome/css/all.css'
import HeadClassDialog from './HeadClassDialog'
import HeadDayDialog from './HeadDayDialog'
import HeadBoundaryDialog from './HeadBoundaryDialog'
import HeadWeftDialog from './HeadWeftDialog'
import HeadUpdataDialog from './HeadUpdataDialog'
import HeadDeliverySetDialog from './HeadDeliverySetDialog'
import store from '../../vuex/index.js'
export default {
  name: 'HeadMenu',
  props: ['regionId', 'regionType', 'regionGeom'],
  components: {
    HeadClassDialog,
    HeadDayDialog,
    HeadBoundaryDialog,
    HeadWeftDialog,
    HeadUpdataDialog,
    HeadDeliverySetDialog
  },
  data () {
    return {
      boundarydata: [],
      prodata: [], // 遥感产品分类数据
      rdate: [],
      pdate: [],
      sdate: [],
      activeIndex: '1',
      activeIndex2: '1',
      dialogFormVisible: false,
      DaydialogFormVisible: false,
      BoundarydialogFormVisible: false,
      WeftdialogFormVisible: false,
      UpdatadialogFormVisible: false,
      SetdialogFormVisible: false,
      selectproducts: [],
      selectrsdatas: [],
      selectsddatas: [],
      productstartdate: '2000-02-26',
      productenddate: this.format('yyyy-MM-dd', new Date()),
      rsstartdate: '',
      rsenddate: '',
      sdstartdate: '',
      sdenddate: '',
      region: {
        code: '',
        type: '',
        regionname: ''
      },
      hours: [],
      remoteSenseFormData: null,
      productpageSize: 50,
      radio: '1',
      setStyle: 'aaa',
      currentPage: 1
    }
  },
  created () {
    this.initclassdata()
    this.initboundaryData()
  },
  computed: {
    dateTitle () {
      let title = ''
      if (this.$route.path === '/remoteSenseData') {
        title = '筛选条件'
      } else if (this.$route.path === '/subscriptionData') {
        title = '筛选条件'
      } else {
        title = '日期选择'
      }
      return title
    }
  },
  methods: {
    showSetDialog () {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user === null) {
        this.$message.warning('请先登录！')
        return
      }
      this.setStyle = 'bbb'
      this.SetdialogFormVisible = true
      this.activeIndex2 = '8'
    },
    showRegionDialog () {
      if (this.$route.path === '/subscriptionData') {
        this.setStyle = 'aaa'
        this.radio === '1' ? this.BoundarydialogFormVisible = true : this.WeftdialogFormVisible = true
      } else {
        this.BoundarydialogFormVisible = true
      }
    },
    showBoundaryDialog (val) {
      this.WeftdialogFormVisible = false
      this.BoundarydialogFormVisible = true
      this.radio = val
    },
    showWeftDialog (val) {
      this.BoundarydialogFormVisible = false
      this.WeftdialogFormVisible = true
      this.radio = val
    },
    format: function (fmt, data) {
      var o = {
        'M+': data.getMonth() + 1,
        'd+': data.getDate(),
        'h+': data.getHours(),
        'm+': data.getMinutes(),
        's+': data.getSeconds(),
        'q+': Math.floor((data.getMonth() + 3) / 3),
        'S': data.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (data.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    },
    initclassdata: function () {
      // 分类查询条件 维度(1应用领域2卫星)
      var dimension = 1
      if (this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
        dimension = 2
      }
      var josndata = {
        dimension: dimension,
        appfieldcode: 0
      }
      this.sapost('/dmc/catalog/catalogs', josndata, r => {
        this.prodata = r.data
      })
    },
    initboundaryData: function () {
      var josndata = {
        type: 'province',
        code: ''
      }
      this.sapost('/dmc/manage/standardProduct/regionList', josndata, r => {
        this.boundarydata = r.data
      })
    },
    getDayDialogDate: function (msg) {
      let sdataid = []
      let startDate = ''
      let endDate = ''
      if (this.$route.path === '/remoteSenseData') {
        this.rsstartdate = msg.data[0]
        this.rsenddate = msg.data[1]
        this.rdate = [new Date(this.rsstartdate), new Date(this.rsenddate)]
        this.remoteSenseFormData = msg.remoteSenseFormData
        sdataid = this.selectrsdatas
        startDate = this.rsstartdate
        endDate = this.rsenddate
      } else if (this.$route.path === '/subscriptionData') {
        this.sdstartdate = msg.data[0]
        this.sdenddate = msg.data[1]
        this.remoteSenseFormData = msg['remoteSenseFormData']
        this.sdate = [new Date(this.rsstartdate), new Date(this.rsenddate)]
        this.radio === '1' ? this.BoundarydialogFormVisible = true : this.WeftdialogFormVisible = true
        this.activeIndex2 = '3'
        sdataid = this.selectsddatas
        startDate = this.sdstartdate
        endDate = this.sdenddate
      } else {
        this.productstartdate = msg.data[0]
        this.productenddate = msg.data[1]
        this.pdate = [new Date(this.productstartdate), new Date(this.productenddate)]
        sdataid = this.selectproducts
        startDate = this.productstartdate
        endDate = this.productenddate
      }
      this.hours = msg.hours
      this.$emit('getHeadspdata', {
        sdataid: sdataid,
        productstartdate: startDate,
        productenddate: endDate,
        hours: this.hours,
        productpageSize: 50,
        currentPage: 1,
        remoteSenseFormData: this.remoteSenseFormData
      })
    },
    // 监听用户选择区域的方式：查询类型(1:行政区划,2:自定义,3:上传文件)
    getQueryType (val) {
      this.$emit('getQueryType', val)
    },
    // 监听用户选择区域的范围
    getRange (val) {
      this.$emit('getRange', val)
    },
    drowp: function (val) {
      this.cleardrow(1)
      this.$emit('drowp', {
      })
      var drawstyle1 = '矩形'
      document.getElementById('drawstyle1').innerHTML = drawstyle1
      document.getElementById('fooderxzqy').innerHTML = ''
      document.getElementById('drawstyle2').innerHTML = ''
      document.getElementById('drawstyle3').innerHTML = ''
      document.getElementById('drawstyle4').innerHTML = ''
    },
    drowd: function (val) {
      this.cleardrow(1)
      this.$emit('drowd', {
      })
      var drawstyle2 = '多边形'
      document.getElementById('drawstyle2').innerHTML = drawstyle2
      document.getElementById('drawstyle1').innerHTML = ''
      document.getElementById('fooderxzqy').innerHTML = ''
      document.getElementById('drawstyle3').innerHTML = ''
      document.getElementById('drawstyle4').innerHTML = ''
    },
    cleardrow: function (value) {
      this.$emit('cleardrow', {
      })
      document.getElementById('fooderxzqy').innerHTML = ''
      document.getElementById('drawstyle1').innerHTML = ''
      document.getElementById('drawstyle2').innerHTML = ''
      document.getElementById('drawstyle3').innerHTML = ''
      document.getElementById('drawstyle4').innerHTML = ''
      if (value === 0) {
        store.commit('setLoading', true)
      }
    },
    getpsis: function (val) {
      let startDate = ''
      let endDate = ''
      if (this.$route.path === '/remoteSenseData') {
        this.selectrsdatas = val
        startDate = this.rsstartdate
        endDate = this.rsenddate
      } else if (this.$route.path === '/subscriptionData') {
        this.selectsddatas = val
        this.DaydialogFormVisible = true
        this.activeIndex2 = '2'
        startDate = this.sdstartdate
        endDate = this.sdenddate
      } else {
        this.selectproducts = val
        startDate = this.productstartdate
        endDate = this.productenddate
      }
      this.$emit('getHeadspdata', {
        sdataid: val,
        productstartdate: startDate,
        productenddate: endDate,
        hours: this.hours,
        productpageSize: 50,
        currentPage: 1,
        remoteSenseFormData: this.remoteSenseFormData
      })
    },
    showClassDialog () {
      this.dialogFormVisible = true
      this.activeIndex2 = '1'
    },
    handleSelect: function (key, keyPath) {
      if (this.$route.path === '/remoteSenseData') {
        this.activeIndex = key
      } else {
        this.activeIndex2 = key
      }
    },
    getDialogMsg: function (msg) {
      this.dialogFormVisible = msg
    },
    getDayDialogMsg: function (msg) {
      this.DaydialogFormVisible = msg
      if (msg) {
        this.activeIndex2 = '2'
      }
    },
    getSetDialogMsg: function (msg) {
      this.SetdialogFormVisible = msg
      if (msg) {
        this.activeIndex2 = '8'
        this.setStyle = 'bbb'
      }
    },
    getBoundaryDialogMsg: function (msg) {
      this.BoundarydialogFormVisible = msg
      if (msg) {
        this.activeIndex2 = '3'
        this.setStyle = 'aaa'
      }
    },
    getWeftDialogMsg: function (msg) {
      this.WeftdialogFormVisible = msg
      if (msg) {
        this.activeIndex2 = '3'
        this.setStyle = 'aaa'
      }
    },
    getUpdataDialogMsg: function (msg) {
      this.UpdatadialogFormVisible = msg
    },
    sendMsgToParentPro: function (msg) {
      this.$emit('getHeadRegioncode', {
        code: msg.code,
        type: msg.type,
        name: msg.regionname
      })
    }
  },
  watch: {
    $route (val) {
      this.initclassdata()
    }
  }
}
</script>
<style>
.rightgo {
  margin-right: 10px;
}
.popdiv {
  cursor: pointer;
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popdiv:hover {
  background-color: rgb(28, 203, 150);
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popper__arrow {
  left: 85px !important;
}
.topmenu {
  margin-left: 17%;
  width: 66%;
  height: 60px;
  /* margin-top: 5px; */
  min-width: 670px;
  overflow-y: hidden;
}
.newpopover[x-placement^="bottom"] {
  margin-top: 12px;
}
.topmenu .el-menu-demo {
  opacity: 0.9;
  border-radius: 35px 35px 35px 35px;
}
.newpopover[x-placement^="bottom"] .popper__arrow::after {
  top: 1px;
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover[x-placement^="bottom"] .popper__arrow {
  top: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover {
  position: absolute;
  background: rgb(25, 27, 46);
  min-width: 130px;
  border-radius: 2px;
  padding: 0px;
  z-index: 2000;
  color: #ffffff;
  line-height: 1.4;
  text-align: justify;
  border: 0px;
  font-size: 14px;
  margin-left: 20px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
.v-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
}
.dialogtop {
  margin-top: 0px;
}
.aaa {
  display: inline-block;
  height: 19px;
  background: url("../../assets/img/4.png") no-repeat center;
  background-size: 21px 21px;
  vertical-align: middle;
}
.bbb {
  display: inline-block;
  height: 19px;
  background: url("../../assets/img/4-.png") no-repeat center;
  background-size: 21px 21px;
  vertical-align: middle;
}
li.el-menu-item.is-active {
  color: rgb(28, 203, 150);
  border-bottom: none;
  background-color: rgb(25, 27, 46);
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadMenu.vue